/** AT04 copy (one group per control; a ticket edits only its own file). */
export const at04PtBr = {
  title: 'Baixas, vendas e transferências de bens',
  description:
    'Baixas, vendas, transferências e baixas de intangíveis registradas contra o valor contábil e o lançamento.',
  prerequisite:
    'Requer a comparação dos eventos registrados com o valor contábil e o lançamento resultante.',
  reasons: {
    DISPOSAL_BOOK_RESULT_MISSING: 'Baixa sem resultado calculado neste livro',
    CARRYING_AMOUNT_DIFFERS:
      'Valor contábil da baixa difere do custo menos a depreciação acumulada no livro',
    RESULT_DIFFERS_FROM_CARRYING_AMOUNT:
      'Ganho ou perda difere do calculado a partir do valor contábil',
    DISPOSAL_WITHOUT_JOURNAL: 'Baixa sem lançamento contábil',
    JOURNAL_DIFFERS_FROM_RESULT:
      'Lançamento da baixa difere do valor contábil e do resultado em alguma conta',
    JOURNAL_OUTSIDE_EVENT_PERIOD: 'Lançamento datado fora do período do evento',
    LEASE_LIABILITY_NOT_DERECOGNIZED: 'Devolução de arrendamento com passivo ainda em aberto',
    ASSET_IDLE_NOT_WRITTEN_OFF: 'Bem baixado fisicamente e não baixado no razão',
    TRANSFER_AMOUNT_NOT_PRESERVED: 'Transferência não preserva o custo do bem',
    TRANSFER_RECOGNISED_INCOME: 'Transferência reconheceu receita ou despesa',
    WRITE_OFF_REASON_MISSING: 'Baixa de intangível sem motivo registrado',
    WRITE_OFF_WITHOUT_JOURNAL: 'Baixa de intangível sem lançamento da perda capitalizada',
    WRITE_OFF_JOURNAL_DIFFERS: 'Lançamento da baixa de intangível difere da perda capitalizada',
  },
  observations: {
    AT04_SCOPE_UNRESOLVED: 'Moeda funcional, período ou livro de lançamento não resolvidos',
    AT04_EVENTS_COMPARED: 'Eventos comparados com o valor contábil e o lançamento',
    AT04_MEMO_BOOK_RESULTS: 'Resultados calculados em livros memoriais, sem lançamento',
    AT04_ASSET_NOT_ON_BOOK: 'Baixas de bens que não constam neste livro',
    AT04_COST_UNMEASURABLE: 'Bens cujo custo no livro não pôde ser medido',
    AT04_WRITE_OFF_OTHER_FRAMEWORK: 'Baixas de intangíveis de outro referencial contábil',
    AT04_ACCOUNT_UNRESOLVED:
      'Eventos cujas contas não puderam ser resolvidas na versão do plano de contas do período',
    AT04_NOT_MEASURABLE_AT_CUTOFF: 'Valores que não puderam ser medidos na data de corte',
    AT04_LEASE_LIABILITY_UNMEASURABLE:
      'Devoluções de arrendamento cujo passivo no razão não pôde ser medido',
    AT04_MEMO_LEASE_LIABILITY_UNMEASURED:
      'Devoluções de arrendamento em livros memoriais, sem razão para conferir o passivo',
    AT04_LEDGER_ACCOUNT_RESTRICTED: 'Contas protegidas fora da comparação',
  },
  coverageLimit:
    'Vendas e descartes que ninguém registrou ficam fora deste controle: o responsável pelo cadastro de bens confirma que não houve outros. A rescisão parcial de arrendamento também fica fora; a rescisão total é uma devolução e é verificada.',
  asset: 'Bem {{code}}',
  project: 'Projeto {{code}}',
  journal: 'Lançamento sem bem identificado',
  openAsset: 'Abrir bem',
  openProject: 'Abrir projeto',
  openLease: 'Abrir contrato',
  listTruncated: 'Mostrando {{shown}} de {{total}} apontamentos.',
};

export const at04En: typeof at04PtBr = {
  title: 'Disposals, sales and transfers of assets',
  description:
    'Recorded disposals, sales, transfers and intangible write-offs against carrying amount and the journal.',
  prerequisite: 'Needs recorded events compared with carrying amount and the resulting journal.',
  reasons: {
    DISPOSAL_BOOK_RESULT_MISSING: 'Disposal with no result computed on this book',
    CARRYING_AMOUNT_DIFFERS:
      'Disposal carrying amount differs from cost less accumulated depreciation on the book',
    RESULT_DIFFERS_FROM_CARRYING_AMOUNT:
      'Gain or loss differs from the one computed from the carrying amount',
    DISPOSAL_WITHOUT_JOURNAL: 'Disposal with no journal',
    JOURNAL_DIFFERS_FROM_RESULT:
      'Disposal journal differs from the carrying amount and result on some account',
    JOURNAL_OUTSIDE_EVENT_PERIOD: 'Journal dated outside the period of the event',
    LEASE_LIABILITY_NOT_DERECOGNIZED: 'Lease return with the liability still open',
    ASSET_IDLE_NOT_WRITTEN_OFF: 'Asset physically retired but not written off in the ledger',
    TRANSFER_AMOUNT_NOT_PRESERVED: 'Transfer does not preserve the asset cost',
    TRANSFER_RECOGNISED_INCOME: 'Transfer recognised income or expense',
    WRITE_OFF_REASON_MISSING: 'Intangible write-off with no reason recorded',
    WRITE_OFF_WITHOUT_JOURNAL: 'Intangible write-off with no journal for the capitalised loss',
    WRITE_OFF_JOURNAL_DIFFERS: 'Intangible write-off journal differs from the capitalised loss',
  },
  observations: {
    AT04_SCOPE_UNRESOLVED: 'Book functional currency, period or posting book not resolved',
    AT04_EVENTS_COMPARED: 'Events compared with carrying amount and journal',
    AT04_MEMO_BOOK_RESULTS: 'Results computed on memo books, not posted',
    AT04_ASSET_NOT_ON_BOOK: 'Disposals of assets that are not on this book',
    AT04_COST_UNMEASURABLE: 'Assets whose book cost could not be measured',
    AT04_WRITE_OFF_OTHER_FRAMEWORK: 'Intangible write-offs under another accounting framework',
    AT04_ACCOUNT_UNRESOLVED:
      "Events whose accounts could not be resolved on the period's chart of accounts version",
    AT04_NOT_MEASURABLE_AT_CUTOFF: 'Amounts that could not be measured at the cutoff date',
    AT04_LEASE_LIABILITY_UNMEASURABLE: 'Lease returns whose ledger liability could not be measured',
    AT04_MEMO_LEASE_LIABILITY_UNMEASURED:
      'Lease returns on memo books, with no ledger to check the liability against',
    AT04_LEDGER_ACCOUNT_RESTRICTED: 'Restricted accounts left out of the comparison',
  },
  coverageLimit:
    'Sales and scrappings nobody recorded are outside this control: the asset register owner confirms there were no others. A partial lease termination is outside it too; a full termination is a return and is checked.',
  asset: 'Asset {{code}}',
  project: 'Project {{code}}',
  journal: 'Journal with no asset identified',
  openAsset: 'Open asset',
  openProject: 'Open project',
  openLease: 'Open contract',
  listTruncated: 'Showing {{shown}} of {{total}} findings.',
};
